import {AfterContentChecked, ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MissionFormComponent} from "../../../mission/mission-form/mission-form.component";
import {GERMAN_LAYOUT} from "../../../core/visbos-core/ui/directives/on-screen-keyboard.directive";
import {KeyboardOptions} from "virtual-keyboard";

@Component({
  selector: 'vb-medicine-withdrawal-auth-form',
  templateUrl: './medicine-withdrawal-auth-form.component.html',
  styleUrls: ['./medicine-withdrawal-auth-form.component.css']
})
export class MedicineWithdrawalAuthFormComponent implements OnInit, AfterContentChecked {

  kbOptions: KeyboardOptions = {
    type: 'input',
    layout: 'custom',
    customLayout: GERMAN_LAYOUT
  };

  @Input()
  touchMode: boolean = false;

  @Input()
  form: FormGroup;

  @Input()
  missionForm: FormGroup;

  @Input()
  reasonFormControl: FormControl;

  @Input()
  formHorizontal: boolean = false;

  constructor(private fb: FormBuilder, private cd: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.initControl();
  }

  ngAfterContentChecked(): void {
    this.cd.detectChanges();
  }

  showMedForm() {
    let check = this.form.get('withdrawal_reason_type').value == 'Einsatz';
    return check;
  }

  showReasonForm() {
    return true;
  }

  initControl() {

    if (!this.form) {
      this.form = this.fb.group({
        personal_number: [null, Validators.required],
        signature: [null, Validators.required],
        withdrawal_reason_type: (this.reasonFormControl ? this.reasonFormControl : [null, Validators.required]),
      });
    }

    if (!this.missionForm) {
      this.missionForm = MissionFormComponent.initControl(this.fb);
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/store-management/withdrawal/medicine-withdrawal-auth-form/medicine-withdrawal-auth-form.component.ts